<label class="switch">
    <input type="checkbox"  [(ngModel)]="value" [ngModelOptions]="{standalone: true}">
    <span class="slider round"></span>
</label>